// analytics.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, EMPTY, take } from 'rxjs';
import { ConsentService } from './consent.service';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {

  private API = 'https://api.scripay.com/analytics';
  private sessionId = crypto.randomUUID();

  constructor(
    private http: HttpClient,
    private consentService: ConsentService
  ) {}

  trackEvent(event: {
    page: string;
    action: string;
    source: 'landing' | 'dashboard';
    userId?: string;
  }): void {
    const consent = this.consentService.getConsent();

    // Do NOT track if user hasn't consented
    if (!consent?.analytics) return;

    const payload = {
      ...event,
      sessionId: this.sessionId,
      timestamp: new Date().toISOString(),
      url: window.location.href
    };

    if (!environment.production) {
      console.log('Tracking event:', event);
      console.log('Tracking payload:', payload);
    }

    this.http.post(this.API, payload, { withCredentials: true })
      .pipe(take(1), catchError(() => EMPTY))
      .subscribe();
  }
}
